import * as React from "react";
import type { SVGProps } from "react";
const SvgIconRadio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5.55c-1.28.08-2.53.5-3.6 1.2q-1.3.86-2.15 2.15c-.45.7-.81 1.52-1 2.31-.5 2.02-.13 4.16 1 5.89q.86 1.3 2.15 2.15c.7.45 1.52.81 2.31 1 2.03.5 4.16.13 5.89-1q1.3-.86 2.15-2.15c.45-.7.81-1.52 1-2.31.42-1.7.23-3.47-.52-5.03-.38-.79-.83-1.42-1.45-2.04Q12 1.44 10.25.87C9.39.6 8.42.48 7.5.55m.01 1.14c-1.92.15-3.69 1.18-4.76 2.78Q1.92 5.7 1.72 7.23c-.04.31-.04 1.23 0 1.54.1.75.28 1.36.6 2.02.33.65.7 1.17 1.21 1.68s1.03.88 1.68 1.2c.66.33 1.27.51 2.02.61.31.04 1.23.04 1.54 0 .75-.1 1.36-.28 2.02-.6.65-.33 1.17-.7 1.68-1.21s.88-1.03 1.2-1.68c.27-.54.43-1 .54-1.57.09-.47.1-.62.1-1.22s-.01-.75-.1-1.22c-.11-.57-.27-1.04-.54-1.57-.32-.65-.69-1.17-1.2-1.68s-1.03-.88-1.68-1.2-1.23-.5-1.97-.6c-.17-.03-.33-.04-.72-.04z"
      fill="#475569"
    />
  </svg>
);
export default SvgIconRadio;
